import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-select/dist/vue-select.css';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import AbstractField from '../abstract-field/abstract-field';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';

import { mixins } from 'vue-class-component';
import { OrderItem } from '@accounting/interfaces/order-item';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Observable } from 'rxjs';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { Invoice } from '@accounting/interfaces/invoice';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { Article } from '@accounting/interfaces/article';
import { TicketHelper } from '@accounting/helpers/TicketHelper';

@Component({
  name: 'pos-checkout-order-items-list',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-field-wrapper': FieldWrapper,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-drawer-modal': DrawerModal,
  },
})
export default class PosCheckoutOrderItemsList extends mixins(AbstractField, AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    changeQuantityConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    changePriceConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    applyDiscountConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    removeConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    changeQuantityStdForm: InstanceType<typeof StdForm> & {
      formModel: any;
      onDeleteMediaFile(): void;
      resetErrorObject(): void;
      manageSaveErrors(error): void;
    };
    changePriceStdForm: InstanceType<typeof StdForm> & {
      formModel: any;
      onDeleteMediaFile(): void;
      resetErrorObject(): void;
      manageSaveErrors(error): void;
    };
    applyDiscountStdForm: InstanceType<typeof StdForm> & {
      formModel: any;
      onDeleteMediaFile(): void;
      resetErrorObject(): void;
      manageSaveErrors(error): void;
    };
    bulkSoftDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    softDeleteConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };

  @Prop(Array) readonly value: any[];

  selectEntity: string = 'order-item';
  selectPluralEntity: string = 'order-items';

  @Prop(String) readonly permissionEntityName: string;

  readonly customFlagsToCheckBeforeLoadEntities: Array<any> = ['configLoaded'];

  public entity: OrderItem = null;
  public entityName = 'order-item';
  public pluralEntityName = 'order-items';
  public permissionEntityNameToUse = 'orders';

  public disableAcceptButton = false;

  public changeQuantitySubscription = null;
  public changePriceSubscription = null;
  public applyDiscountSubscription = null;
  public removeSubscription = null;
  public softDeleteSubscription = null;

  public successText: string = 'global.generic.successful_action';
  public errorText: string = 'global.generic.error_form_action';

  processedItems: object[] = [];

  public customPageActions = {
    bulkChangeQuantity: {
      activated: false,
      type: 'action',
      icon: null,
      variant: 'secondary',
      text: 'change_quantity',
      show: true,
      event: 'bulkChangeQuantity',
      selectElements: true,
      tag: 'right',
      permissions: ['bulk_edit'],
    },
    bulkApplyDiscount: {
      activated: false,
      type: 'action',
      icon: 'percent',
      variant: 'secondary',
      text: 'apply_discount',
      show: true,
      event: 'bulkApplyDiscount',
      selectElements: true,
      tag: 'right',
      permissions: ['bulk_edit'],
    },
    bulkChangePrice: {
      activated: false,
      type: 'action',
      icon: 'euro-sign',
      variant: 'secondary',
      text: 'change_price',
      show: true,
      event: 'bulkChangePrice',
      selectElements: true,
      tag: 'right',
      permissions: ['bulk_edit'],
    },
    bulkRemove: {
      activated: false,
      type: 'action',
      icon: 'ban',
      variant: 'secondary',
      text: 'remove',
      show: true,
      event: 'bulkRemove',
      selectElements: true,
      tag: 'right',
      permissions: ['bulk_edit'],
    },
  };

  providerMounted = false;

  get changeQuantityConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'change-quantity-modal',
      title: this.$t('global.modals.change_quantity.title'),
      body: this.$t('global.modals.change_quantity.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
    };
  }
  get changePriceConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'change-price-modal',
      title: this.$t('global.modals.change_price.title'),
      body: this.$t('global.modals.change_price.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
    };
  }
  get applyDiscountConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'apply-discount-modal',
      title: this.$t('global.modals.apply_discount.title'),
      body: this.$t('global.modals.apply_discount.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
    };
  }
  get removeConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'remove-modal',
      title: this.$t('global.modals.remove_of_invoice.title'),
      body: this.$t('global.modals.remove_of_invoice.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
    };
  }

  mounted() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].mounted(this);
    }
    this.$root.$on('refresh-pos-order-items', () => {
      this.$refs.provider.getEntities();
    });
  }
  destroyed() {
    if (this.$eventsService.events[this.entityName]) {
      this.$eventsService.events[this.entityName].destroy(this);
    }
    this.$root.$off('refresh-pos-order-items');
  }

  beforeMount() {
    this.entityName = this.selectEntity;
    this.pluralEntityName = this.selectPluralEntity;
  }

  get showedFields() {
    const showedFields = [];
    for (const field of this.$refs.provider.fields) {
      if (!field['conditionalShow']) {
        showedFields.push(field);
      } else {
        const keys = field['conditionalShow']['fieldPath'].split('.');
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let conditionalValue = this;
        for (const key of keys) {
          if (conditionalValue[key] != 'undefined') {
            conditionalValue = conditionalValue[key];
          } else {
            break;
          }
        }
        if (conditionalValue === field['conditionalShow']['value']) {
          showedFields.push(field);
        }
      }
    }
    return showedFields;
  }

  // FOR PRINT WELL AFTER POS OPEN TICKETS HAVE CHANGED
  // When the list of open tickets change we have to recall onLoadItems function to set the order items in the current ticket in order to print well
  get posOpenTickets() {
    return this.$store.getters['pos/openTickets'];
  }

  @Watch('posOpenTickets')
  onChangePosOpenTickets() {
    this.onLoadItems();
  }

  @Watch('orderItemsToProcess')
  onChangeOrderItemsToProcess() {
    if (this.orderItemsToProcess.length > 0) {
      this.$set(this.$refs.provider, 'items', this.orderItemsToProcess);
      this.updateRowsActions();
      this.onLoadItems();
    }
  }

  onLoadItems() {
    setTimeout(() => {
      if (this.$refs.entityTable) {
        this.$refs.entityTable.$on('on-click-display', $event => {
          if (this.displayFieldsToSubscribe.includes($event.field)) {
            this.onEdit($event, true);
          }
        });
      }
    });
    this.processedItems = [];
    if (this.$refs.provider.items.length > 0) {
      this.processedItems = TicketHelper.processOrderItems(this.$refs.provider.items);
      this.$store.dispatch(`pos/addOrderItemsToTicket`, { processedItems: this.processedItems });
      this.$store.commit('pos/storeOrderItemsToProcess', []);
    }
  }
  get orderItemsToProcess(): [] {
    return this.$store.getters['pos/orderItemsToProcess'];
  }
  processOrderItems(items: any[]) {
    let order: any = { id: null };
    const newProcessedItems = [];
    items.forEach((orderItem: OrderItem) => {
      if (orderItem.order_id != order.id) {
        order = orderItem['order'];
        order.total_price = orderItem.total_price;
        order['article_name'] = order.description;
        order['parent'] = true;
        order['_rowVariant'] = 'order';
        newProcessedItems.push(orderItem['order']);
      } else {
        order.total_price += orderItem.total_price;
      }
      newProcessedItems.push(orderItem);
    });
    return newProcessedItems;
  }
  onCheckAll(val) {
    this.processedItems.forEach((item: object) => {
      this.$set(item, 'checked', val);
    });
  }
  getSelection() {
    const selection = [];
    if (this.processedItems) {
      this.processedItems.forEach(element => {
        if (element['checked']) {
          const selected = {
            id: element['id'],
            entity: element['parent'] ? 'order' : 'orderItem',
          };
          selection.push(selected);
        }
      });
    }
    this.selection = [...selection];
    this.extendUpdatePageActions();
  }

  // get checkedAll(): { value: boolean } {
  //   let unchecked = null;
  //   if (this.processedItems) {
  //     unchecked = this.processedItems.find((item: { checked?: boolean }) => !item.checked);
  //   }
  //   return { value: !unchecked };
  // }

  /**
   * Overwrite method of abstract-table to add eventos for custom page actions.
   * @param $event
   */
  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulkChangeQuantity':
        this.$refs.changeQuantityConfirmationModal.onOpenModal(null);
        this.togglePosModalsOpened();
        break;
      case 'bulkChangePrice':
        this.$refs.changePriceConfirmationModal.onOpenModal(null);
        this.togglePosModalsOpened();
        break;
      case 'bulkApplyDiscount':
        this.$refs.applyDiscountConfirmationModal.onOpenModal(null);
        this.togglePosModalsOpened();
        break;
      case 'bulkRemove':
        this.$refs.removeConfirmationModal.onOpenModal(null);
        break;
    }
    console.log('Page Title event >>> ' + $event);
  }

  togglePosModalsOpened() {
    this.$store.commit('pos/toggleModalsOpened');
  }

  changeQuantity() {
    this.disableAcceptButton = true;
    const data = {
      ids: this.getSelectedOrderItems(),
      new_quantity: this.$refs.changeQuantityStdForm.formModel.new_quantity,
    };

    const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'order-item',
    )}/bulk-change-quantity`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(saveEntityPath, data);

    if (this.changeQuantitySubscription) {
      this.changeQuantitySubscription.unsubscribe();
    }
    this.changeQuantitySubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: this.successText });
        this.onSuccessChangeQuantity();
        this.disableAcceptButton = false;
      },
      error => {
        this.$bpcMessage.showErrorMessage({ text: this.errorText });
        this.$refs.changeQuantityStdForm.resetErrorObject();
        this.$refs.changeQuantityStdForm.manageSaveErrors(error);
        this.disableAcceptButton = false;
      },
    );
  }
  changePrice() {
    this.disableAcceptButton = true;
    const data = {
      ids: this.getSelectedOrderItems(),
      new_price: this.$refs.changePriceStdForm.formModel.new_price,
    };

    const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'order-item',
    )}/bulk-change-price`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(saveEntityPath, data);

    if (this.changePriceSubscription) {
      this.changePriceSubscription.unsubscribe();
    }
    this.changePriceSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: this.successText });
        this.onSuccessChangePrice();
        this.disableAcceptButton = false;
      },
      error => {
        this.$bpcMessage.showErrorMessage({ text: this.errorText });
        this.$refs.changePriceStdForm.resetErrorObject();
        this.$refs.changePriceStdForm.manageSaveErrors(error);
        this.disableAcceptButton = false;
      },
    );
  }
  applyDiscount() {
    this.disableAcceptButton = true;
    const data = {
      ids: this.getSelectedOrderItems(),
      discount: this.$refs.applyDiscountStdForm.formModel.discount,
    };

    const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'order-item',
    )}/bulk-apply-discount`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(saveEntityPath, data);

    if (this.applyDiscountSubscription) {
      this.applyDiscountSubscription.unsubscribe();
    }
    this.applyDiscountSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: this.successText });
        this.onSuccessApplyDiscount();
        this.disableAcceptButton = false;
      },
      error => {
        this.$bpcMessage.showErrorMessage({ text: this.errorText });
        this.$refs.applyDiscountStdForm.resetErrorObject();
        this.$refs.applyDiscountStdForm.manageSaveErrors(error);
        this.disableAcceptButton = false;
      },
    );
  }
  remove() {
    this.disableAcceptButton = true;
    const data = {
      ids: this.getSelectedOrders(),
    };

    const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath(
      'order',
    )}/bulk-remove-of-invoice`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(saveEntityPath, data);

    if (this.removeSubscription) {
      this.removeSubscription.unsubscribe();
    }
    this.removeSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: this.successText });
        this.onSuccessRemove();
        this.disableAcceptButton = false;
      },
      error => {
        this.$bpcMessage.showErrorMessage({ text: this.errorText });
        this.disableAcceptButton = false;
      },
    );
  }
  bulkSoftDelete() {
    this.disableAcceptButton = true;
    const data = {
      ids: this.getSelectedOrderItems(),
    };

    const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('order-item')}/pos-bulk-delete`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.post(saveEntityPath, data);

    if (this.softDeleteSubscription) {
      this.softDeleteSubscription.unsubscribe();
    }
    this.softDeleteSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: this.successText });
        this.onSuccessBulkSoftDelete();
        this.disableAcceptButton = false;
      },
      error => {
        this.$bpcMessage.showErrorMessage({ text: this.errorText });
        this.disableAcceptButton = false;
      },
    );
  }

  onSoftDelete($event) {
    this.rowSoftDelete($event);
  }

  rowSoftDelete($event) {
    const data = {
      id: $event.item.id,
    };

    const saveEntityPath = `${this.$bpcApiRouteHelper.getEntityPath('order-item')}/pos-delete/${
      data.id
    }`;
    const observable: Observable<BPCGenericApiResponse> = this.$bpcApi.delete(saveEntityPath, data);

    if (this.softDeleteSubscription) {
      this.softDeleteSubscription.unsubscribe();
    }
    this.softDeleteSubscription = observable.subscribe(
      (res: BPCGenericApiResponse) => {
        this.$bpcMessage.showSuccessMessage({ text: this.successText });
        this.onSuccessRowSoftDelete();
      },
      error => {
        this.$bpcMessage.showErrorMessage({ text: this.errorText });
      },
    );
  }

  extendUpdateRowActions(entity: any) {
    if (this.rowActions.softDelete?.show === true) {
      entity.actions['softDelete'].show =
        entity.order.type_value === 'article' || entity.order.type === 'article';
    }
  }

  onSuccessChangeQuantity() {
    this.refreshTicket();
    this.$refs.changeQuantityConfirmationModal.onCloseModal();
  }
  onSuccessChangePrice() {
    this.refreshTicket();
    this.$refs.changePriceConfirmationModal.onCloseModal();
  }
  onSuccessApplyDiscount() {
    this.refreshTicket();
    this.$refs.applyDiscountConfirmationModal.onCloseModal();
  }
  onSuccessRemove() {
    this.refreshTicket();
    this.$refs.removeConfirmationModal.onCloseModal();
  }
  onSuccessBulkSoftDelete() {
    this.refreshTicket();
    this.$refs.bulkSoftDeleteConfirmationModal.onCloseModal();
  }
  onSuccessRowSoftDelete() {
    this.refreshTicket();
  }

  getSelectedOrderItems() {
    const ids = [];
    this.selection.forEach(item => {
      if (item.entity == 'orderItem') {
        ids.push(item.id);
      }
    });
    return ids;
  }
  getSelectedOrders() {
    const ids = [];
    this.selection.forEach(item => {
      if (item.entity == 'order') {
        ids.push(item.id);
      }
    });
    return ids;
  }

  get currentTicketId(): number {
    return this.$store.getters['pos/currentTicketId'];
  }
  get currentTicket(): Invoice {
    return this.$store.getters['pos/currentTicket'];
  }

  refreshTicket(): void {
    const currentTicketId = this.currentTicketId;
    this.$store.commit('pos/clearCurrentTicket');
    setTimeout(() => {
      this.$store.dispatch('pos/getOpenTickets');
      this.$store.commit('pos/storeCurrentTicketId', currentTicketId);
    });
  }

  get showEntityTable(): boolean {
    return this.$refs?.provider?.fields?.length > 0;
  }

  extendUpdatePageActions() {
    if (this.pageActions['bulkChangeQuantity']) {
      this.pageActions['bulkChangeQuantity'].show =
        this.getSelectedOrderItems().length > 0 && this.currentTicket?.status != 'paid';
    }
    if (this.pageActions['bulkApplyDiscount']) {
      this.pageActions['bulkApplyDiscount'].show =
        this.getSelectedOrderItems().length > 0 && this.currentTicket?.status != 'paid';
    }
    if (this.pageActions['bulkChangePrice']) {
      this.pageActions['bulkChangePrice'].show =
        this.getSelectedOrderItems().length > 0 && this.currentTicket?.status != 'paid';
    }
    if (this.pageActions['bulkRemove']) {
      this.pageActions['bulkRemove'].show =
        this.getSelectedOrders().length > 0 && this.currentTicket?.status != 'paid';
    }
    if (this.pageActions['bulkSoftDelete']) {
      this.pageActions['bulkSoftDelete'].show =
        this.$refs.provider &&
        this.$refs.provider.queryConfig.params.status !== 'trash' &&
        !this.$refs.provider.queryConfig.params.onlyTrashed &&
        this.getSelectedOrderItems().length > 0 &&
        this.currentTicket?.status != 'paid';
    }
  }

  onEdit(e, disabled = false) {
    this.entity = e.item;
    this.showForm = true;
    this.showDrawerSection = true;
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }

  onFormSaved($event: any = null) {
    this.onFormClose();
    this.$refs.provider.getEntities();
    this.$store.dispatch('pos/getOpenTickets');
  }

  get addingArticleToTicket() {
    return this.$store.getters['pos/changingOrdersOfTicket'];
  }

  get articleNameToAdd(): Article {
    return (
      this.$store.getters['pos/articleToAdd']?.short_name ||
      this.$store.getters['pos/articleToAdd']?.name
    );
  }
}
